import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, Typography, Icon, Paper } from '@material-ui/core'
import { Panel } from 'src/shared/Panel'
import { RootState } from 'src/core/redux/reducer'
import { compose } from 'redux'
import { withI18n } from 'src/core/i18n'
import { withRouter, RouteComponentProps } from 'react-router'
import { connect } from 'react-redux'
import classNames from 'classnames'


const styles = (t: Theme) => createStyles({
    panel: {
        display: 'flex',
        alignItems: 'center',
        padding: `${t.spacing.unit * 2}px ${t.spacing.unit * 3}px`,
        background: 'rgba(0, 0, 0, 0.12)',
        border: 'none',
        boxShadow: t.shadows[2],
        cursor: 'pointer',
        borderRadius: '4px 4px 0 0'
    },
    dashBlock: {
        marginBottom: '15px'
    },
    scrollable: {
        overflow: 'auto'
    },
    body: {
        boxShadow: '0px 1px 5px 0px rgb(0 0 0 / 12%), 0px 2px 2px 0px rgb(0 0 0 / 0%), 0px 3px 1px -2px rgb(0 0 0 / 0%)',
        borderRadius: '0 0 4px 4px',
        overflow: 'hidden'
    },
    withoutBoxShadow: {
        boxShadow: 'none !important',
    }
});

interface IProps extends
    RouteComponentProps<any>,
    WithStyles<typeof styles>,
    ReturnType<typeof state2props> {
    icon: string;
    label: string;
    redirect: string;
    children: any;
    headerClickableRedirectOnly?: boolean
    noShadow?: boolean
}
class DashboardPanel extends React.Component<IProps, undefined> {

    redirectTo = (url: string) => {
        this.props.history.push(`/ptf/enterprise/${this.props.enterprise.id}/${url}`)
    }

    render () {
        const {classes, label, icon, redirect, headerClickableRedirectOnly, noShadow = false, children} = this.props;
        return (
            <div className={classes.dashBlock}>
                <div 
                    {...!headerClickableRedirectOnly && {onClick: () => this.redirectTo(redirect)}}
                >
                    <Panel 
                        {...headerClickableRedirectOnly && {onClick: () => this.redirectTo(redirect)}}
                        className={classes.panel}
                    >
                        <Typography ><Icon style={{marginRight: '10px', display: 'block'}}>{icon}</Icon></Typography>
                        {label}
                    </Panel>
                    <Paper className={classNames(classes.body, noShadow ? classes.withoutBoxShadow : '')}>
                        <div className={classes.scrollable}>
                            {children}
                        </div>
                    </Paper>
                </div>
            </div>
        )
    }
    
}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
});

export default compose(
    withI18n,
    withRouter,
    withStyles(styles),
    connect(state2props, null),
)(DashboardPanel)



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/DashboardPanel.tsx